import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailDocumentIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 31 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.37502 24.8501H23.1251C25.1825 24.8501 26.8501 23.1825 26.8501 21.1251V9.87502C26.8501 7.81758 25.1825 6.15 23.1251 6.15H7.37502C5.31758 6.15 3.65 7.81758 3.65 9.87502V21.1251C3.65 23.1825 5.31758 24.8501 7.37502 24.8501Z",
			stroke: "currentColor",
			strokeWidth: .7
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12.9348 15.2357L4 9.87502C4 8.01088 5.51088 6.5 7.37502 6.5H23.1251C24.9892 6.5 26.5001 8.01088 26.5001 9.87502L17.5653 15.2357C16.1399 16.0907 14.3602 16.0907 12.9348 15.2357Z" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7547 15.5358L12.7548 15.5358C14.291 16.4573 16.2092 16.4573 17.7454 15.5358L17.7454 15.5358L26.6802 10.1751L26.8501 10.0732V9.87502C26.8501 7.81758 25.1825 6.15 23.1251 6.15H7.37502C5.31758 6.15 3.65 7.81758 3.65 9.87502V10.0732L3.81993 10.1751L12.7547 15.5358Z",
			stroke: "currentColor",
			strokeWidth: .7
		})
	]
});
export default SvgEmailDocumentIcon;
